<div class="manage-assign-users">
  <!-- Organization Name Header -->
  <header class="org-name-header">
    <h3>Organization: {{organizationName }}</h3> <!-- Bind organization name dynamically -->
  </header>
  <!-- Close Button -->
  <button mat-icon-button class="close-button" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
 
  <!-- Assigned Users Section -->
  <section class="assigned-users">
   
    <h3>Assigned Users</h3>
  
    <!-- Show message if no users are assigned -->
    <div *ngIf="!assignedUsers || assignedUsers.length === 0" class="no-users-message">
      An admin is required for the organization. Please assign an admin.
    </div>
  
    <!-- Show table if users are assigned -->
    <table *ngIf="assignedUsers && assignedUsers.length > 0" mat-table [dataSource]="assignedUsers" class="mat-elevation-z8">
      <!-- User Name Column -->
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef> User ID </th>
        <td mat-cell *matCellDef="let user"> {{ user.userName }}</td>
      </ng-container>
  
      <!-- Role Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef> Role </th>
        <td mat-cell *matCellDef="let user"> {{ getRole(user.roleId) }} </td>
      </ng-container>
  
      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email </th>
        <td mat-cell *matCellDef="let user"> {{ user.emailAddress }} </td>
      </ng-container>
  
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Action</th>
        <td mat-cell *matCellDef="let user">
          <button mat-icon-button color="warn" (click)="removeUser(user.userOrganizationId)">
            <mat-icon> delete_forever </mat-icon>
          </button>
        </td>
      </ng-container>
  
      <!-- Table Headers and Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </section>
  

  <!-- Assign New Users Section -->
  <section class="assign-new-users">
    <!-- <h3>Assign New Users</h3>
    <span ><mat-icon color="primary" (click)="OpenUserEntryDialog()">add</mat-icon></span><span style="color: #00bcd4; margin-left: -10px;margin-top: 4px;" (click)="OpenUserEntryDialog()">Add Admin</span> -->
    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">

  <h3 style="margin: 0;">Assign New Users</h3>

  <div style="display: flex; align-items: center; cursor: pointer;"
       (click)="OpenUserEntryDialog()">

    <mat-icon color="primary" style="font-size: 18px;">add</mat-icon>
    <span style="color: #00bcd4; margin-left: 4px;">Add Admin</span>

  </div>

</div>


    <form [formGroup]="assignUsersForm" (ngSubmit)="assignUsers()">
      <!-- Select Users -->
      <mat-form-field appearance="fill" class="user-select">
        <mat-label>Select Users</mat-label>
        <mat-select formControlName="selectedUsers" multiple required>
          <mat-option *ngFor="let user of availableUsers" [value]="user.userId">
            {{ user.userName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="assignUsersForm.get('selectedUsers')?.hasError('required')">
          At least one user is required.
        </mat-error>
      </mat-form-field>

      <!-- Assign Role -->
      <mat-form-field appearance="fill" class="role-select">
        <mat-label>Assign Role</mat-label>
        <mat-select formControlName="selectedRole" required>
          <mat-option *ngFor="let userType of userTypes" [value]="userType.id">
            {{ userType.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="assignUsersForm.get('selectedRole')?.hasError('required')">
          Role is required.
        </mat-error>
      </mat-form-field>

      <!-- Assign Users Button -->
      <button mat-raised-button color="primary" type="submit" [disabled]="assignUsersForm.invalid">
            Assign Users
      </button>
    </form>
  </section>
</div>
